<template>
  <b-overlay
    :show="busy"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <div class="email-response box-shadow">
      <AddEmails type="bcc" />
      <hr />
      <AddEmails type="cc" />
      <hr />
      <AddEmails type="to" @input="emailArray" v-model="copyTo" />
      <hr />

      <b-form-input
        v-model="cannedResponseSelected"
        class="email-response--canned-responses"
        list="responses"
        placeholder="Canned responses"
        aria-label="Canned responses"
        autocomplete="off"
      ></b-form-input>

      <datalist id="responses">
        <option v-for="response in responses" v-bind:key="response.id">
          {{ response.name }}
        </option>
      </datalist>

      <div id="primevue-editor" class="email-response__body-message">
        <!-- <Editor editorStyle="height: 500px;" v-model="messageBody" /> -->
        <FroalaEditor v-model="messageBody" :content="newContent" />
      </div>
    </div>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
/* import Editor from "primevue/editor"; */
import FroalaEditor from "../FroalaEditor.vue";
import englishTable from "@/utils/LTL/cannedResponses/englishTable";
import spanishTable from "@/utils/LTL/cannedResponses/spanishTable";
import AddEmails from "./AddEmails";
import { removePointerEvents } from "@/mixins/pickupAndDelivery/standardizers";
// import { mapState } from "vuex";

export default {
  name: "EmailResponse",
  props: {
    tripsComponent: Object
  },
  components: {
    /*  Editor, */
    AddEmails,
    FroalaEditor
  },
  data() {
    return {
      messageBody: "",
      newContent: "",
      responses: null,
      listsType: null,
      cannedResponseSelected: null,
      copyTo: [],
      quoteById: null,
      busy: false,
      totalHuCountAux: null,
      commodityAux: [],
      finalTable: null,
      user: null,
      cannedResponseSelectedById: null,
      clientEmailsArray: null,
      selectedMode: null
    };
  },
  computed: {
    ...mapGetters("cannedResponses", ["getCannedResponses"]),
    ...mapGetters("quotes/quote", ["showSelectedMode"])
  },
  watch: {
    async showSelectedMode(value) {
      this.selectedMode = value;
      this.getResponsesFromCanned();
    },
    async getCannedResponses(value) {
      this.responses = value;
    },
    async cannedResponseSelected() {
      let cannedResponseSelectedInfo = this.responses.find(
        element => element.name == this.cannedResponseSelected
      );
      // Nuevos cambios Admin Panel
      if (this.cannedResponseSelected && cannedResponseSelectedInfo?.id) {
        let currentDepartment = JSON.parse(
          localStorage.getItem("current-department")
        );
        let info = {
          department_id: currentDepartment.department_id,
          canned_id: cannedResponseSelectedInfo.id,
          mode_name: this.selectedMode
        };
        const response = await this.$store.dispatch(
          "cannedResponses/getCannedResponseById",
          info
        );
        this.cannedResponseSelectedById = cannedResponseSelectedInfo.id;
        this.$emit("cannedSelected", this.cannedResponseSelectedById);
        this.setCannedResponseSelected(response.data);
      }
    },
    messageBody() {
      this.returnResponse();
    }
  },
  async beforeMount() {
    this.responses = this.getCannedResponses;
    this.quoteById = this.$store.getters["quotes/quote/showQuoteById"];
    this.returnResponse();
  },
  mounted() {
    let userAux = localStorage.getItem("charlie-username-otr");
    this.user = JSON.parse(userAux);
    if (
      this.user[0].rol.id == "3" &&
      (this.$route.params.pathName == "queue" ||
        this.$route.params.pathName == "failed" ||
        this.$route.params.pathName == "alerts")
    ) {
      removePointerEvents("primevue-editor");
    }
    this.selectedMode = this.showSelectedMode;
  },
  methods: {
    emailArray(value) {
      this.clientEmailsArray = value;
      this.$emit("getClientEmailsArray", this.clientEmailsArray);
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async setCannedResponseSelected(infoCannedById) {
      // Cambios con integracion del Admin Panel
      if (this.cannedResponseSelected == infoCannedById.name) {
        if (
          this.$store.getters["login/showUserLoggedIn"][0].department.name ==
          "ltl"
        ) {
          this.newContent = infoCannedById.html;
        } else {
          this.newContent.replace("{hauls_info}", "Tabla aquí!!!!!");
        }
        this.$emit("cannedResponseChanged", true);
        return;
      } else {
        this.newContent = "";
        this.$emit("cannedResponseChanged", false);
      }
      return;
    },
    async createTableLTL(response) {
      let quoteId = this.$route.params.id;
      await this.$store.dispatch("quotes/quote/getQuote", quoteId);
      this.quoteById = await this.$store.getters["quotes/quote/showQuoteById"];
      let tables = "";
      for (let i in this.quoteById.haul) {
        let table;
        if (response.language == "en") {
          table = englishTable;
        } else if (response.language == "es") {
          table = spanishTable;
        }
        table = table.replaceAll(
          "haul_id_shp",
          `{haul_${this.quoteById.haul[i].id}}`
        );
        let origin =
          this.quoteById.haul[i].city_from +
          ", " +
          this.quoteById.haul[i].state_from +
          " - " +
          this.quoteById.haul[i].zip_from;
        table = table.replace("origin_zip_code_table", origin);
        let destination =
          this.quoteById.haul[i].city_to +
          ", " +
          this.quoteById.haul[i].state_to +
          " - " +
          this.quoteById.haul[i].zip_to;
        table = table.replace("destination_zip_code_table", destination);
        let totalUnits = this.quoteById.haul[i].total_hu_count;
        if (totalUnits.includes("HU")) {
          totalUnits = totalUnits.replace("HU", "Unit(s)");
        }
        table = table.replace("number_of_pieces_table", totalUnits);
        table = table.replace(
          "total_weight_table",
          this.quoteById.haul[i].total_weight
        );
        let accessorials = await this.getAccessorialsLtl(i);
        table = table.replace("all_accessorials_table", accessorials);
        let dimensions = await this.getDimensions(i);
        table = table.replace("all_dimensions_table", dimensions);
        let totalVol = await this.quoteById.haul[i].cbf;
        if (totalVol.includes("cbf")) {
          totalVol = totalVol.replace("cbf", "Cbf");
        }
        table = table.replace("cubic_feet_table", totalVol);
        if (this.quoteById.haul[i].linear_feet != null) {
          let linearFeet = this.quoteById.haul[i].linear_feet + " Lft";
          table = table.replace("linear_feet_table", linearFeet);
        } else {
          table = table.replace("linear_feet_table", "");
        }
        let commodity = await this.getCommodityLtl(i);
        table = table.replace("all_commodity_table", commodity);
        table = table + `<br>{table_haul_${this.quoteById.haul[i].id}}<br>`;
        tables = tables + table;
      }
      this.finalTable = tables;
      //this.messageBody = response.html;
    },
    async getNormalList() {
      let messageBodyAux = this.$store.getters.showCannedResponses[
        this.cannedResponseSelected
      ];
      for (let i = 0; i < this.quoteById.haul.length; i++) {
        let huCountAux = await this.getTotalHuCount(i);
        let weightAux = await this.getTotalWeight(i);
        let dimensionsAux = await this.getDimensions(i);
        let commodityAux = this.getCommodity(i);
        this.listsType[this.cannedResponseSelected].push(
          `<br>${
            this.quoteById.haul[i].shp
          }</br><br><b style='color: #17A2B8;'>--- FREIGHT DETAILS TRIP ${i +
            1} ---</b><ul><li><b>Origin:</b> ${
            this.quoteById.haul[i].city_from
          } - ${this.quoteById.haul[i].zip_from}</li><li><b>Destination:</b> ${
            this.quoteById.haul[i].city_to
          } - ${
            this.quoteById.haul[i].zip_to
          }</li><li><b>Number of pieces:</b> ${huCountAux}</li><li><b>Total weight:</b> ${weightAux}</li><li><b>Dimensions:</b></li>${dimensionsAux}<li><b>Commodity:</b></li>${commodityAux}</ul><br>`
        );
      }
      let lists = "";
      for (let trip in this.listsType[this.cannedResponseSelected]) {
        lists = lists + this.listsType[this.cannedResponseSelected][trip];
      }
      this.newContent = messageBodyAux.replace(
        "<b>---FREIGHT-DETAILS-HERE---</b><br><br>",
        lists
      );
    },
    async getHeavyHaulList() {
      let messageBodyAux = this.$store.getters.showCannedResponses[
        this.cannedResponseSelected
      ];
      for (let i = 0; i < this.quoteById.haul.length; i++) {
        let specs = await this.getSpecs(i);
        if (this.cannedResponseSelected == "HEAVY HAUL QUOTE") {
          this.listsType[this.cannedResponseSelected].push(
            `<b>${
              this.quoteById.haul[i].shp
            }</b><br><b style='color: #17A2B8;'>--- FREIGHT DETAILS TRIP ${i +
              1} ---</b><ul><li><b>Origin:</b> ${
              this.quoteById.haul[i].city_from
            } - ${
              this.quoteById.haul[i].zip_from
            }</li><li><b>Destination:</b> ${this.quoteById.haul[i].city_to} - ${
              this.quoteById.haul[i].zip_to
            }</li><li><b>Equipment:</b> Flatbed or Stepdeck</li><li><b>Specs:</b></li>${specs}<li><b>Notes:</b> <b>Non hazmat cargo</b></li><li><b>TT:</b></li></ul><br>`
          );
        } else if (this.cannedResponseSelected == "HEAVY HAUL PARTIAL QUOTE") {
          this.listsType[this.cannedResponseSelected].push(
            `<b>${
              this.quoteById.haul[i].shp
            }</b><br><b style='color: #17A2B8;'>--- FREIGHT DETAILS TRIP ${i +
              1} ---</b><ul><li><b>Origin:</b> ${
              this.quoteById.haul[i].city_from
            } - ${
              this.quoteById.haul[i].zip_from
            }</li><li><b>Destination:</b> ${this.quoteById.haul[i].city_to} - ${
              this.quoteById.haul[i].zip_to
            }</li><li><b>Equipment:</b> Flatbed or Stepdeck</li><li><b>Specs:</b></li>${specs}<li><b>Notes:</b> NON DG Cargo - Not in Bond</li></ul><br>`
          );
        }
      }
      let lists = "";
      for (let trip in this.listsType[this.cannedResponseSelected]) {
        lists = lists + this.listsType[this.cannedResponseSelected][trip];
      }
      this.newContent = messageBodyAux.replace(
        "<b>---FREIGHT-DETAILS-HERE---</b><br><br>",
        lists
      );
    },
    async getTotalHuCount(i) {
      this.totalHuCountAux = [];
      for (let item of this.quoteById.haul[i].commodity) {
        if (item.hu_count != null && item.hu_count != "") {
          this.totalHuCountAux.push(item.hu_count);
        }
      }
      let info = {};
      info.hu_count = this.totalHuCountAux;
      let response = await this.$store.dispatch("totals/getTotalHuCount", info);
      let totalHu;
      if (
        this.$store.getters["login/showUserLoggedIn"][0].department.name !=
        "ltl"
      ) {
        totalHu =
          response.data.split(" ")[0] +
          " " +
          this.$store.getters.showHandlingUnitsHuCount[i];
      } else {
        totalHu = response.data.split(" ")[0] + " HU";
      }
      return totalHu;
    },
    async getCalculateVolumeAndDensity(i) {
      let huCountArray = [];
      let dimensionsArray = [];
      for (let item of this.quoteById.haul[i].commodity) {
        if (item.hu_count != null && item.hu_count != "") {
          huCountArray.push(item.hu_count);
        }
        if (item.dimensions != null && item.dimensions != "") {
          dimensionsArray.push(item.dimensions);
        }
      }
      if (
        huCountArray.length === 0 ||
        dimensionsArray.length === 0 ||
        dimensionsArray.length !== huCountArray.length
      ) {
        return { volume: null, density: null };
      }
      let info = {};
      info.dimensions = dimensionsArray;
      info.hu_count = huCountArray;
      let response = await this.$store.dispatch(
        "totals/getCalculateVolumeAndDensity",
        info
      );
      return response.data;
    },
    async getTotalWeight(i) {
      let totalWeightAux = [];
      for (let item of this.quoteById.haul[i].commodity) {
        if (item.weight != null && item.weight != "") {
          totalWeightAux.push(item.weight);
        }
      }
      let info = {};
      info.hu_count = this.totalHuCountAux;
      info.weight = totalWeightAux;
      let response = await this.$store.dispatch("totals/getTotalWeight", info);
      return response.data;
    },
    getAccessorialsLtl(i) {
      let accessorialsAux = `<div style="list-style-type: none; margin: 0; padding: 0;">`;
      for (let item of this.quoteById.haul[i].accessorial) {
        let accessorialAux =
          item.accessorial.name.charAt(0).toUpperCase() +
          item.accessorial.name.slice(1);
        if (item.accessorial.accessorial_type != "general") {
          if (accessorialAux == "Cfs") {
            accessorialAux = accessorialAux.toUpperCase();
          }
          accessorialAux =
            accessorialAux + " - " + item.accessorial.accessorial_type;
        } else if (accessorialAux == "Amazon") {
          accessorialAux = accessorialAux + " delivery by appointment";
        } else if (accessorialAux == "Tsa") {
          accessorialAux = accessorialAux.toUpperCase();
        }
        accessorialsAux =
          accessorialsAux +
          `<p style="padding: 4px 0px; margin: 0;">${accessorialAux}</p>`;
      }
      accessorialsAux = accessorialsAux + `</div>`;
      return accessorialsAux;
    },
    getDimensions(i) {
      let totalDimensionsAux = `<div style="list-style-type: none; margin: 0; padding: 0;">`;
      for (let item of this.quoteById.haul[i].commodity) {
        if (item.dimensions != null && item.dimensions != "") {
          totalDimensionsAux =
            totalDimensionsAux +
            `<p style="padding: 4px 0px; margin: 0;">${item.dimensions} - ${item.hu_count}</p>`;
        }
      }
      totalDimensionsAux = totalDimensionsAux + `</div>`;
      return totalDimensionsAux;
    },
    getCommodity(haul) {
      this.commodityAux = [];
      let commodity = `<div style="list-style-type: none; margin: 0; padding: 0;">`;
      for (
        let i = 0;
        i < this.quoteById.model_response.entities.commodity.length;
        i++
      ) {
        commodity =
          commodity +
          `<p style="padding: 4px 0px; margin: 0;">${this.quoteById.model_response.entities.commodity[i]}</p>`;
        this.commodityAux.push(
          this.quoteById.model_response.entities.commodity[i]
        );
      }
      for (let i = 0; i < this.tripsComponent.items[haul].length; i++) {
        if (this.tripsComponent.items[haul][i].commodity) {
          if (
            !this.commodityAux.includes(
              this.tripsComponent.items[haul][i].commodity
            )
          ) {
            commodity =
              commodity +
              `<p style="padding: 4px 0px; margin: 0;">${this.tripsComponent.items[haul][i].commodity}</p>`;
            this.commodityAux.push(
              this.tripsComponent.items[haul][i].commodity
            );
          }
        }
      }
      commodity = commodity + `</div>`;
      return commodity;
    },
    getCommodityLtl(i) {
      let commodity = `<div style="list-style-type: none; margin: 0; padding: 0;">`;
      let commodityAux = [];
      for (let j in this.quoteById.haul[i].commodity) {
        if (
          this.quoteById.haul[i].commodity[j].description != null &&
          this.quoteById.haul[i].commodity[j].description != ""
        ) {
          if (
            !commodityAux.includes(
              this.quoteById.haul[i].commodity[j].description
            )
          ) {
            commodityAux.push(this.quoteById.haul[i].commodity[j].description);
            commodity += `<p style="padding: 4px 0px; margin: 0;">${this.quoteById.haul[i].commodity[j].description}</p>`;
          }
        }
      }
      commodity += `</div>`;
      return commodity;
    },
    getSpecs(i) {
      let specs = `<ul>`;
      for (let item of this.quoteById.haul[i].commodity) {
        specs =
          specs +
          `<li>${item.hu_count}, ${item.dimensions}, ${item.weight}</li>`;
      }
      specs = specs + `</ul>`;
      return specs;
    },
    returnResponse() {
      let responseEmail = {};
      responseEmail.messageBody = this.messageBody;
      for (let response of this.responses) {
        if (this.cannedResponseSelected == response.name) {
          responseEmail.language = response.language;
        }
      }
      let emailsCopy = "";
      for (let i = 0; i < this.copyTo.length; i++) {
        emailsCopy = emailsCopy + this.copyTo[i] + ",";
      }
      if (emailsCopy.slice(-1) == ",") {
        let emailsCopyAux = emailsCopy.slice(0, -1);
        responseEmail.emails = emailsCopyAux;
      } else {
        responseEmail.emails = emailsCopy;
      }
      return this.$emit("input", responseEmail);
    },
    async getResponsesFromCanned() {
      this.currentDepartment = JSON.parse(
        localStorage.getItem("current-department")
      );
      this.responses = await this.$store.dispatch(
        "cannedResponses/getCannedResponses",
        this.selectedMode
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.email-response {
  @include card;
  margin: $margin-most-used;
  padding: 20px;

  &--canned-responses {
    margin-top: 10px;
  }

  &__body-message {
    margin-top: 20px;
  }
}

::v-deep .p-editor-container {
  .p-editor-toolbar {
    background-color: $color-background-input !important;
    display: flex;
    justify-content: flex-start;
  }

  .ql-editor {
    text-align: justify !important;
  }
}
</style>
